'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.singleton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _HTTPService = require('./HTTPService.js');

var _HTTPService2 = _interopRequireDefault(_HTTPService);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var singleton = exports.singleton = Symbol.for('instance');
var singletonEnforcer = Symbol.for('enforcing');

var hs_instance = _HTTPService2.default.hs_instance;


var _logLevel = "";
var _serviceURL = "";
var _logIndex = 0;
var _pid = "";

var LogService = function () {
	function LogService(enforcer) {
		_classCallCheck(this, LogService);

		if (enforcer !== singletonEnforcer) {
			throw new Error('Cannot construct a singleton');
		}
	}

	_createClass(LogService, [{
		key: 'init',
		value: function init(url, logIndex, logLevel, data) {
			_serviceURL = url;
			_logIndex = logIndex;
			_logLevel = logLevel;
			_pid = data.pid;
		}
	}, {
		key: 'submitLogMessage',
		value: function submitLogMessage(plid, src, message) {

			if (_logLevel === 'off') return;
			var timeStamp = new Date().getTime();
			var msg = {};
			msg.ts = new Date(timeStamp).toISOString();
			msg.pid = _pid;
			msg.plid = plid;
			msg.src = src;
			msg.message = message;
			hs_instance.post(_serviceURL + '/' + _logIndex + '/' + _logLevel, msg).then(function (response) {
				//success
			}).catch(function (error) {
				console.log('[LogService] There has been a problem with your fetch operation: ', error.message);
			});
		}
	}], [{
		key: 'ls_instance',
		get: function get() {
			if (!LogService[singleton]) {
				LogService[singleton] = new LogService(singletonEnforcer);
			}

			return LogService[singleton];
		}
	}]);

	return LogService;
}();

exports.default = LogService;